import React, { useEffect, useState } from "react";
import formBg from "../../Assets/Images/circleForm.jpeg";
import arrowIcon from "../../Assets/Images/arrow_Right_20dp_FILL_wght300.png";
import "./BuildBusiness.css";
import rightMarkIcon from "../../Assets/Images/rightMarkIcon.png";
import arrowLeftIcon from "../../Assets/Images/arrow-left-tech.png";
import "./NewContact.css";
import ContactInfo from "./ContactInfo";
import { Link } from "react-router-dom";

const StartHiringDev = () => {
  const [hireType, setHireType] = useState("solo");
  const [contactType, setContactType] = useState("hire");

  const [selectedRoles, setSelectedRoles] = useState([]);

  const handleRoleChange = (role) => {
    setSelectedRoles((prev) =>
      prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const developerRoles = [
    "JavaScript Developer",
    ".NET Developer",
    "Node.js Developer",
    "Android Developer",
    "SQL Developer",
    "Frontend Developer",
    "React Native Developer",
    "Blazor Expert",
    "Azure Expert",
  ];
  return (
    <div>
      <div className={contactType === "hire" ? "hire-active" : "hire-inactive"}>
        <div>
          <img
            className="img-fluid form-img-contact start-contact-content"
            style={{
              zIndex: "0",
              position: "relative",
              marginBottom: "5rem",
              height: "1200px",
            }}
            src={formBg}
            alt=""
          />
        </div>
      </div>

      <div
        className="tech-start-left-container   container-text"
        style={{ position: "absolute" }}
      >
        <Link to="/contact-us/build-business">
          <img
            style={{ padding: " 3rem 2rem 1rem 2rem" }}
            className="d-flex d-lg-none"
            src={arrowLeftIcon}
            alt=""
          />
        </Link>
        <h2 className="tech-start-heading">
          Add Development Power Without Hiring Friction
        </h2>
        <p className="start-tech-text">
          Sometimes you need people, not process. Our cooperation model helps
          you extend your team without the delays of traditional hiring.
        </p>
        <ul className="list-unstyled">
          <li className="tech-start-li ">
            {" "}
            <span className="p-3">
              <img
                src={rightMarkIcon}
                alt="right icon"
                className="hiring-list__check-icon"
              />
            </span>
           Hire experienced solo developers
          </li>
          <li className="tech-start-li">
            <span className="p-3">
              <img
                src={rightMarkIcon}
                alt="right icon"
                className="hiring-list__check-icon"
              />
            </span>
            Scale with dedicated teams
          </li>
          <li className="tech-start-li">
            <span className="p-3">
              <img
                src={rightMarkIcon}
                alt="right icon"
                className="hiring-list__check-icon"
              />
            </span>
            Stay in control of delivery
          </li>
        </ul>
      </div>
      {/* right section */}
      <div
        className="container tech-start-right-container form-section"
        style={{
          top: "200px",
          zIndex: "1",
          left: "50%",
          maxWidth: "600px",
          position: "absolute",
          backgroundColor: "white",
          padding: "30px 25px",
          borderRadius: "15px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <form>
          {/* 🔹 Contact Type Toggle */}
          <div className="mb-3">
            <div className=" d-flex gap-3 mb-4 top-radio-buttons">
              <label className="radio-pill">
                <input
                  className="custom-radio"
                  type="radio"
                  name="contactType"
                  value="business"
                  checked={contactType === "business"}
                  onChange={() => setContactType("business")}
                />
                <span style={{ color: "#616161" }} className="px-2 fw-semibold">
                  For your Business
                </span>
              </label>

              <label className="radio-pill">
                <input
                  className="custom-radio"
                  type="radio"
                  name="contactType"
                  value="hire"
                  checked={contactType === "hire"}
                  onChange={() => setContactType("hire")}
                />
                <span style={{ color: "#616161" }} className="px-2 fw-semibold">
                  For Hire Developers/Team
                </span>
              </label>
            </div>
          </div>

          {/* 🔹 Common Fields */}
          <div className="mb-3">
            <label
              style={{
                fontWeight: "400",
                fontSize: "1.5rem",
                color: "#616161",
              }}
            >
              Full Name
            </label>
            <input
              type="text"
              placeholder="Enter your name"
              style={inputStyle}
            />
          </div>

          <div className="mb-3">
            <label
              style={{
                fontWeight: "400",
                fontSize: "1.5rem",
                color: "#616161",
              }}
            >
              Email
            </label>
            <input
              type="email"
              placeholder="Enter your e-mail"
              style={inputStyle}
            />
          </div>

          <div className="mb-3">
            <label
              style={{
                fontWeight: "400",
                fontSize: "1.5rem",
                color: "#616161",
              }}
            >
              Mobile
            </label>
            <input
              type="text"
              placeholder="Enter your phone number"
              style={inputStyle}
            />
          </div>

          {/* 🔹 Business Section */}
          {contactType === "business" && (
            <>
              <div className="mb-3">
                <label
                  style={{
                    fontWeight: "400",
                    fontSize: "1.5rem",
                    color: "#616161",
                  }}
                >
                  Subject
                </label>
                <input
                  type="text"
                  placeholder="Enter your title"
                  style={inputStyle}
                />
              </div>

              <div className="mb-3">
                <label
                  style={{
                    fontWeight: "400",
                    fontSize: "1.5rem",
                    color: "#616161",
                  }}
                >
                  Description
                </label>
                <textarea
                  rows="3"
                  placeholder="Write down your message"
                  style={textareaStyle}
                ></textarea>
              </div>
            </>
          )}

          {/* 🔹 Hire Section */}
          {contactType === "hire" && (
            <>
              {/* Hire Type Toggle */}
              <div className="toggle-contact   gap-3 mb-3">
                <label
                  className=""
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    paddingLeft: "12px",
                  }}
                >
                  <div className="" style={{ display: "flex", padding: "0px" }}>
                    <input
                      className="custom-radio"
                      type="radio"
                      name="hireType"
                      value="solo"
                      checked={hireType === "solo"}
                      onChange={() => setHireType("solo")}
                    />
                    <span
                      style={{ color: "#616161", fontSize: "1.5rem" }}
                      className="px-2"
                    >
                      Hire Solo Developer
                    </span>
                  </div>
                  {hireType === "solo" && (
                    <div className="developer-list">
                      {developerRoles.map((role) => (
                        <label
                          className="border border-0"
                          key={role}
                          style={{
                            color: "#616161",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: "13px",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedRoles.includes(role)}
                            onChange={() => handleRoleChange(role)}
                          />
                          {role}
                        </label>
                      ))}
                    </div>
                  )}
                </label>

                <label className="">
                  <input
                    className="custom-radio"
                    type="radio"
                    name="hireType"
                    value="team"
                    checked={hireType === "team"}
                    onChange={() => setHireType("team")}
                  />
                  <span
                    style={{ color: "#616161", fontSize: "1.5rem" }}
                    className="px-2"
                  >
                    Development Team
                  </span>
                </label>
              </div>

              {/* Solo Developer Options */}

              {/* Description */}
              <div className="mb-3 mt-4">
                <label
                  style={{
                    fontWeight: "400",
                    fontSize: "1.5rem",
                    color: "#616161",
                  }}
                >
                  Description
                </label>
                <textarea
                  rows="3"
                  placeholder="Describe your requirements"
                  style={textareaStyle}
                ></textarea>
              </div>
            </>
          )}

          {/* Note + Button */}
          <p style={{ fontSize: "12px", color: "#9ca3af" }}>
            A note for extra info
          </p>

          <button
            type="submit"
            className="btn  rounded-pill"
            style={{
              backgroundColor: "#B8EBF5",
              color: "#FAFAFA",
              fontWeight: "500",
              border: " 1px solid #95E1F0",
              padding: "10px 16px",
              fontSize: "1.3rem",
            }}
          >
            {contactType === "business" ? "SEND MESSAGE " : "SEND REQUEST "}
            <span>
              <img src={arrowIcon} alt="" />
            </span>
          </button>
        </form>
      </div>
      <ContactInfo></ContactInfo>
    </div>
  );
};
const inputStyle = {
  width: "100%",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  padding: "10px",
  fontSize: "14px",
  outline: "none",
};

const textareaStyle = {
  ...inputStyle,
  resize: "none",
};

export default StartHiringDev;
